import { Button } from '@cian/ui-kit';
import * as React from 'react';
import { ViewContainer } from '../ViewContainer';
import { TitleContainer } from '../TitleContainer';
import { EmailSentInfo } from '../../components/EmailSentInfo';
import { ESentEmailType } from '../../types/sentEmail';
import { EActiveView } from '../../types/view';
import { EEventType } from '../../types/events';
import { ContentLayout } from '../../components/ContentLayout';
import { trackRegistrationDonePopup, trackRegistrationDonePopupClose, trackResetPasswordGotItClick } from '../../utils/tracking';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function EmailSentViewContainer(_ref) {
  var viewData = _ref.viewData,
    source = _ref.source,
    reset = _ref.reset,
    changeLogin = _ref.changeLogin,
    emit = _ref.emit,
    changeView = _ref.changeView;
  var handleGotItClick = React.useCallback(function () {
    switch (viewData.type) {
      case ESentEmailType.Restore:
        if (viewData.nextView) {
          changeView(viewData.nextView);
          break;
        }
        trackResetPasswordGotItClick(source);
        reset();
        changeLogin(viewData.email);
        changeView(EActiveView.AuthenticationRegistration);
        emit(EEventType.EmailSentClosed, {
          type: ESentEmailType.Restore
        });
        break;
      case ESentEmailType.Registration:
        trackRegistrationDonePopupClose(source);
        emit(EEventType.EmailSentClosed, {
          type: ESentEmailType.Registration
        });
        break;
    }
  }, [changeLogin, changeView, emit, reset, viewData.email, viewData.nextView, viewData.type, source]);
  React.useEffect(function () {
    if (viewData.type === ESentEmailType.Registration) {
      trackRegistrationDonePopup(source);
    }
  }, [viewData.type, source]);
  return /*#__PURE__*/_jsxs(ViewContainer, {
    children: [/*#__PURE__*/_jsx(TitleContainer, {}), /*#__PURE__*/_jsx(EmailSentInfo, {
      viewData: viewData
    }), /*#__PURE__*/_jsx(ContentLayout, {
      children: /*#__PURE__*/_jsx(Button, {
        "data-name": "GotItBtn",
        fullWidth: true,
        theme: "fill_primary",
        onClick: handleGotItClick,
        children: "\u0425\u043E\u0440\u043E\u0448\u043E"
      })
    })]
  });
}